import { render } from "./SquareVectorSvg.vue?vue&type=template&id=a0b7d1c2"
import script from "./SquareVectorSvg.vue?vue&type=script&lang=js"
export * from "./SquareVectorSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__